import { Dropdown } from 'components/dropdown/Dropdown.tsx';
import { IconOption, type IconOptionType } from 'components/dropdown/options/IconOption';
import { localize } from 'i18n/localize.ts';
import { type WhereSold } from 'service/offer/model';

const $t = localize();

export type WithdrawOptionId = 'soldOnSbazar' | 'soldElsewhere' | 'soldNoInfo';
export const withdrawOptions: IconOptionType<WithdrawOptionId>[] = [
	{ id: 'soldOnSbazar', icon: 'check_circle' },
	{ id: 'soldElsewhere', icon: 'account_balance_wallet' },
	{ id: 'soldNoInfo', icon: 'outgoing_mail' },
];

export const denormalizeReasonMap = new Map<WithdrawOptionId, WhereSold>([
	['soldOnSbazar', 'sold_sbazar'],
	['soldElsewhere', 'sold_other'],
	['soldNoInfo', 'not_specified'],
]);

export const renderIconOption = ({
	props,
	option,
	isFocused,
	aria,
	id,
	iconSize,
}: Dropdown.RenderOptionProps<IconOptionType<WithdrawOptionId>>) => (
	<IconOption
		className="text-sm"
		label={$t.offer.withdrawOptions[option.id]}
		icon={option.icon}
		props={props}
		isFocused={isFocused}
		aria={aria}
		id={id}
		dataTest={option.id}
		iconSize={iconSize}
	/>
);
